import i18n from '../i18n';

function inactiveSuffix() {
  return i18n.t('common.inactiveSuffix', { defaultValue: ' (Inactive)' });
}

/**
 * Person given/family names: Unicode letters (incl. accents), combining marks,
 * spaces, hyphens, apostrophes. Blocks digits and other symbols.
 * Examples: François, Müller, José, Élodie, van der Berg, O'Brien, Jean-Luc
 */
export const isValidPersonName = (value) => {
  if (value == null) return false;
  const s = String(value).trim();
  if (!s) return false;
  return /^[\p{L}\p{M}](?:[\p{L}\p{M}'’.\- ]*[\p{L}\p{M}])?$/u.test(s);
};

export const formatFullName = (firstNameOrUser, middleName, lastName) => {
  // If first argument is an object (user), extract properties
  if (typeof firstNameOrUser === "object" && firstNameOrUser !== null) {
    const user = firstNameOrUser;
    if (user.displayName) {
      return user.displayName;
    }
    const parts = [];
    if (user.firstName) parts.push(user.firstName);
    if (user.middleName) parts.push(user.middleName);
    if (user.lastName) parts.push(user.lastName);
    let name = parts.join(" ");
    const suffix = inactiveSuffix();
    if (user.permanentlyRemoved && name && !name.endsWith(suffix)) {
      name += suffix;
    }
    return name;
  }

  // Otherwise, treat as separate parameters
  const parts = [];
  if (firstNameOrUser) parts.push(firstNameOrUser);
  if (middleName) parts.push(middleName);
  if (lastName) parts.push(lastName);
  return parts.join(" ");
};

/** Append (Inactive) when API returns a bare name for a permanently removed user. */
export const withInactiveSuffix = (name, permanentlyRemoved) => {
  const suffix = inactiveSuffix();
  if (!permanentlyRemoved || !name || name.endsWith(suffix)) {
    return name || "";
  }
  return name + suffix;
};
